module.exports = __webpack_public_path__ + "static/agatawork1-386e88b9014fcd585464c8b3200afe0a.jpg";